<template>
    <div :class="['m-portlet',{'full-height': fullHeight},  {'footer':hasFooter}, {'separated': hasHeader && headSeparator}]">
        <div v-if="hasHeader" :class="['m-portlet__head', {inverted:invertedHeader}]">
            <div  class="m-portlet__head-top">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            <slot name="Title">
                                {{title}}
                            </slot>
                        </h3>
                    </div>
                </div>
                <div class="m-portlet__head-tools">
                    <slot name="Options"></slot>
                </div>
            </div>

            <slot name="Search"></slot>

            <div class="portlet-nav">
                <slot name="PortletNav"></slot>
            </div>
        </div>

        <div :class="['m-portlet__body', {'no-padding':noPadding}]">
            <slot name="Content">
            </slot>
            <div v-if="hasFooter">
                <slot name="Footer"></slot>
            </div>
        </div>

    </div>
</template>

<script >
    import EventBus from '@/eventbus';
    export default {
        name: 'Portlet',
        props: {
            title: String
            , invertedHeader: Boolean
            , fullHeight: Boolean
            , headSeparator: Boolean
            , noPadding: { type: Boolean, default: false }
            , hasHeader: { type: Boolean, default: true }
            , hasSearch: { type: Boolean, default: false }
            , hasFooter: { type: Boolean, default: false }
            , smallHeader: { type: Boolean, default: false }
        },
        watch: {
            title: function() {
                this.$forceUpdate();
            }
        },
        data() {
            return {
                modalState: {
                    show: true,
                    visible: true,
                },
            };
        },
        methods: {
            toggleAdvancedSearch() {
                this.searchOpen = false;
                this.$router.push({ name: 'AdvancedSearchQuery' });
            },
            cancelAdvancedSearch() {
                this.$refs['modal'].hide();
            },
        }
    };
</script>

<style scoped lang="scss" type="text/less">

    .m-portlet {
        background: transparent;
    }

    .m-portlet__head {
        background: white;
        display: flex;
        flex-direction: column;
    }

    .m-portlet__body {
        background: white;
    }

        .m-portlet__body.no-padding {
            padding: 0;
        }

    /* .header-separator {
        height: 10px;
        background: transparent;
    } */

    .m-portlet__head-top {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0 0 5px;
    }

    .m-portlet__head-caption {
        width: 100%;
    }

    .m-portlet .m-portlet__head .m-portlet__head-caption .m-portlet__head-title .m-portlet__head-text {
        align-items: flex-end;
        // margin: 0 auto 0 auto;

        small {
            margin-left: 24px;
            padding-left: 0;
            font-size: 13px;
            font-weight: 400;
            line-height: 1.3;
            vertical-align: baseline;
            color: #aaa;
        }
    }

    .m-portlet.full-height {
        margin-bottom: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

        .m-portlet.full-height .m-portlet__body {
            overflow-y: auto;
            // padding: 15px; // Let the child responsibility
            height: 100%;
        }

            .m-portlet.full-height .m-portlet__body.no-padding {
                padding: 0;
            }

    .m-portlet .portlet-nav {
        display: flex;
    }

    .m-portlet__head {
        height: auto;
    }

    .m-portlet__head-tools {
        .portlet-search-toggle,button.portlet-search-toggle {
            margin: 0 15px;
            padding: 7px 0px 7px 10px;
            background: transparent;
            border: none;
            i {
                margin-right: 10px;
                font-size: 16px;
            }
        }
    }


    .m-portlet.full-height.BoxConstraints .m-portlet__body,

    .m-portlet.full-height.PlanningLogs .m-portlet__body,
    .m-portlet.full-height.PlanningDetails .m-portlet__body,
    .m-portlet.full-height.PlanningStats .m-portlet__body,
    .m-portlet.full-height.PlanningPodcasts .m-portlet__body,
    .m-portlet.PlanningStats .m-portlet__body{
        padding:0 !important;
    }
    .m-portlet.full-height.PlanningStats .m-portlet__body {
        background:transparent;
    }

</style>
